import { inr } from "@/data/content";

export const PhonePeQr = ({ amount, compact = false }) => (
  <div className="flex flex-col items-center" data-testid="phonepe-qr">
    <div className="p-3 bg-white rounded-2xl gold-border shadow-lg shadow-amber-500/10">
      <img
        src="/phonepe-qr-v2.jpeg"
        alt="PhonePe payment QR - MRG Group of Companies"
        className={compact ? "w-48 h-auto" : "w-64 h-auto"}
        data-testid="phonepe-qr-image"
      />
    </div>
    <p className="font-mono-lux text-[11px] tracking-[0.2em] text-amber-400 uppercase mt-4">
      Scan & pay via PhonePe / any UPI app
    </p>
    <p className="text-sm text-zinc-300 mt-1">Payee: MRG GROUP OF COMPANIES</p>
    {amount > 0 && (
      <p className="text-sm text-zinc-400 mt-1">
        Amount to pay:{" "}
        <span className="font-mono-lux gold-text font-700" data-testid="phonepe-qr-amount">
          {inr(amount)}
        </span>
      </p>
    )}
  </div>
);
